var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAssets10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.66 13.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #ffd510;\n        stroke-width: .53px;\n      }\n\n      .st1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4.84,
    cy: 3.74,
    r: 2.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M.8,12.45v-2.7c0-.9.73-1.62,1.62-1.62h4.81c.9,0,1.62.73,1.62,1.62v2.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAssets10);
export default __webpack_public_path__ + "static/media/SVG_assets-10.23d354aaf5c587d49fef280608eadbea.svg";
export { ForwardRef as ReactComponent };